"use client";

import { usePathname } from "next/navigation";
import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
type NavItemProps = {
  title: string;
  url: string;
  icon?: React.ReactNode;
};

export function NavItem({ title, url, icon }: NavItemProps) {
  const pathname = usePathname();
  const isActive = url !== "#" && (pathname === url || pathname.startsWith(url + "/"));

  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild isActive={isActive} tooltip={title}>
        <a href={url}>
          {icon}
          {title}
        </a>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
